"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteComment = exports.fetchComment = exports.fetchComments = exports.postComment = exports.removeSentiment = exports.postSentiment = exports.CommentsNamespaces = exports.SentimentTypes = exports.SentimentNamespaces = void 0;
require("url-search-params-polyfill");
var helpers_1 = require("./helpers");
var constants_1 = require("./constants");
var constants_2 = require("./constants");
Object.defineProperty(exports, "SentimentNamespaces", { enumerable: true, get: function () { return constants_2.SENTIMENT_NAMESPACES; } });
Object.defineProperty(exports, "SentimentTypes", { enumerable: true, get: function () { return constants_2.SENTIMENT_TYPES; } });
Object.defineProperty(exports, "CommentsNamespaces", { enumerable: true, get: function () { return constants_2.COMMENTS_NAMESPACES; } });
var sentiments_1 = require("./sentiments");
Object.defineProperty(exports, "postSentiment", { enumerable: true, get: function () { return sentiments_1.postSentiment; } });
Object.defineProperty(exports, "removeSentiment", { enumerable: true, get: function () { return sentiments_1.removeSentiment; } });
var client_platform_web_network_1 = require("@wattpad/client-platform-web-network");
/**
 * Makes sure resource is valid ie.
 * - Namespace must be in the COMMENTS_NAMESPACES constant
 * - Namespace requires the corresponding id(s)
 *    - Namespace "parts" requires resource.partId
 *    - Namespace "paragraphs" requires resource.partId and resource.paragraphId
 *    - Namespace "comments" requires resource.commentId
 *
 * Rejects with error and logs to console if not valid.
 *
 * @param resource The namespace and id(s) of a resource.
 * @param resource.namespace Namespace of a resource.
 * @param resource.partId Id of a story part.
 * @param resource.paragraphId Id of a paragraph within a story part.
 * @param resource.commentId Id of a comment.
 * @param funcName Name of the calling function. Will be logged on failed validation.
 * @returns Rejected Promise with error on failed validation. Undefined otherwise.
 */
function validateResourceParams(resource, funcName) {
    var partId = resource === null || resource === void 0 ? void 0 : resource.partId;
    var paragraphId = resource === null || resource === void 0 ? void 0 : resource.paragraphId;
    var parentCommentId = resource === null || resource === void 0 ? void 0 : resource.commentId;
    // determine what ids need to be logged for error clarity
    var idDesc = "";
    if (resource.namespace === constants_1.COMMENTS_NAMESPACES.COMMENTS) {
        idDesc = "parentCommentId: " + parentCommentId;
    }
    else if (resource.namespace === constants_1.COMMENTS_NAMESPACES.PARAGRAPHS) {
        idDesc = "partId: " + partId + ", paragraphId: " + paragraphId;
    }
    else if (resource.namespace === constants_1.COMMENTS_NAMESPACES.PARTS) {
        idDesc = "partId: " + partId;
    }
    if (!resource) {
        var desc = "Must have a valid resource parameter";
        var errMessage = "client-platform-comments: ".concat(funcName, " Failed error: Missing resource parameter");
        var logMsg = "client-platform-comments: ".concat(funcName, " Failed, ").concat(idDesc, ", error: ").concat(desc);
        return (0, helpers_1.invalidParam)(logMsg, errMessage, desc);
    }
    // check if resource name is valid
    if (resource.namespace != constants_1.COMMENTS_NAMESPACES.PARAGRAPHS &&
        resource.namespace != constants_1.COMMENTS_NAMESPACES.PARTS &&
        resource.namespace != constants_1.COMMENTS_NAMESPACES.COMMENTS) {
        var desc = "Must have a valid resource namespace";
        var errMessage = "client-platform-comments: ".concat(funcName, " Failed error: Invalid resource namespace");
        var logMsg = "client-platform-comments: ".concat(funcName, " Failed namespace: ").concat(resource.namespace, ", ").concat(idDesc, ", error: ").concat(desc);
        return (0, helpers_1.invalidParam)(logMsg, errMessage, desc);
    }
    // check fetching replies without a commentId case
    if (resource.namespace === constants_1.COMMENTS_NAMESPACES.COMMENTS && !parentCommentId) {
        var desc = "Must have a valid commentId field in resource when using the comments namespace";
        var errMessage = "client-platform-comments: ".concat(funcName, " Failed error: Missing commentId field in resource");
        var logMsg = "client-platform-comments: ".concat(funcName, " Failed namespace: ").concat(resource.namespace, ", ").concat(idDesc, ", error: ").concat(desc);
        return (0, helpers_1.invalidParam)(logMsg, errMessage, desc);
    }
    // check if partId is missing for parts and paragraphs namespaces
    if ((resource.namespace === constants_1.COMMENTS_NAMESPACES.PARAGRAPHS ||
        resource.namespace === constants_1.COMMENTS_NAMESPACES.PARTS) &&
        !partId) {
        var desc = "Must have a valid partId field in resource when using the parts or paragraphs namespace";
        var errMessage = "client-platform-comments: ".concat(funcName, " Failed error: Missing partId field in resource");
        var logMsg = "client-platform-comments: ".concat(funcName, " Failed namespace: ").concat(resource.namespace, ", ").concat(idDesc, ", error: ").concat(desc);
        return (0, helpers_1.invalidParam)(logMsg, errMessage, desc);
    }
    // paragraphId is defined as optional, but required when in paragraph namespace
    if (resource.namespace === constants_1.COMMENTS_NAMESPACES.PARAGRAPHS && !paragraphId) {
        var desc = "Must have a valid paragraphId field in resource when using the paragraphs namespace";
        var errMessage = "client-platform-comments: ".concat(funcName, " Failed error: Missing paragraphId field in resource");
        var logMsg = "client-platform-comments: ".concat(funcName, " Failed namespace: ").concat(resource.namespace, ", ").concat(idDesc, ", error: ").concat(desc);
        return (0, helpers_1.invalidParam)(logMsg, errMessage, desc);
    }
}
/**
 * Maps a comment in v5 form to a Comment type object.
 *
 * @param response The v5-style comment to be mapped to a v4 comment.
 * @returns Comment object.
 */
function buildCommentObject(response) {
    var labels = response.labels, comment = __rest(response, ["labels"]);
    var _a = comment.user, badges = _a.badges, user = __rest(_a, ["badges"]);
    // interacted is only true if interaction is not null
    Object.keys(comment.sentiments).forEach(function (sentiment) {
        comment.sentiments[sentiment].interacted =
            !!comment.sentiments[sentiment].interaction;
        if (comment.sentiments[sentiment].interaction)
            delete comment.sentiments[sentiment].interaction;
    });
    delete comment.status;
    var commentData = __assign(__assign({}, comment), { user: __assign(__assign({}, user), { isStaff: !!(badges === null || badges === void 0 ? void 0 : badges.includes("staff")), isVerified: !!(badges === null || badges === void 0 ? void 0 : badges.includes("verified")), isStar: !!(badges === null || badges === void 0 ? void 0 : badges.includes("star")), isAmbassador: !!(badges === null || badges === void 0 ? void 0 : badges.includes("ambassador")) }), isOffensive: !!(labels === null || labels === void 0 ? void 0 : labels.includes("offensive")), isReply: comment.resource.namespace == constants_1.COMMENTS_NAMESPACES.COMMENTS, sentiments: new Map(Object.entries(comment.sentiments)) });
    return commentData;
}
/**
 * Posts a comment to a given resource.
 *
 * @param {TempResource}resource The namespace and id(s) of a resource.
 * @param resource.namespace Namespace of a resource.
 * @param resource.partId Id of a story part.
 * @param resource.paragraphId Id of a paragraph within a story part.
 * @param resource.commentId Id of a comment.
 * @param commentBody Text that is to be posted to the indicated resource
 * @returns Comment object if fetch is successful, otherwise returns a rejected promise.
 */
function postComment(resource, commentBody) {
    return __awaiter(this, void 0, void 0, function () {
        var paragraphId, partId, parentCommentId, namespace, idDesc, errMessage, description, logMessage, url, body, options;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    paragraphId = resource === null || resource === void 0 ? void 0 : resource.paragraphId;
                    partId = resource === null || resource === void 0 ? void 0 : resource.partId;
                    parentCommentId = resource === null || resource === void 0 ? void 0 : resource.commentId;
                    namespace = resource === null || resource === void 0 ? void 0 : resource.namespace;
                    // check parameter validity
                    return [4 /*yield*/, validateResourceParams(resource, "postComment")];
                case 1:
                    // check parameter validity
                    _a.sent();
                    if (!commentBody) {
                        idDesc = "";
                        if (resource.namespace === constants_1.COMMENTS_NAMESPACES.COMMENTS) {
                            idDesc = "parentCommentId: " + parentCommentId;
                        }
                        else if (resource.namespace === constants_1.COMMENTS_NAMESPACES.PARAGRAPHS) {
                            idDesc = "partId: " + partId + ", paragraphId: " + paragraphId;
                        }
                        else if (resource.namespace === constants_1.COMMENTS_NAMESPACES.PARTS) {
                            idDesc = "partId: " + partId;
                        }
                        errMessage = "client-platform-comments: postComment Failed error: Invalid comment text";
                        description = "text cannot be null or undefined";
                        logMessage = "client-platform-comments: postComment Failed namespace: ".concat(namespace, ", ").concat(idDesc, ", error: ").concat(description);
                        return [2 /*return*/, (0, helpers_1.invalidParam)(logMessage, errMessage, description)];
                    }
                    if (namespace === constants_1.COMMENTS_NAMESPACES.PARTS) {
                        url = (0, helpers_1.buildDomain)("/v4/parts/".concat(partId, "/comments"));
                        body = { body: commentBody };
                    }
                    else if (namespace === constants_1.COMMENTS_NAMESPACES.PARAGRAPHS) {
                        url = (0, helpers_1.buildDomain)("/v4/parts/".concat(partId, "/paragraphs/").concat(paragraphId, "/comments"));
                        body = {
                            body: commentBody,
                            // endposition is required and has to be greater than startPosition.
                            // this number was agreed by Client Platform AN, IOS and WEB: (2^31-1)
                            endPosition: 2147483647,
                            startPosition: 0,
                        };
                    }
                    else {
                        url = (0, helpers_1.buildDomain)("/v4/comments/".concat(parentCommentId));
                        body = { body: commentBody };
                    }
                    options = {
                        url: url,
                        method: "POST",
                        timeoutValue: constants_1.LONG_TIMEOUT_VALUE,
                        body: body,
                    };
                    return [2 /*return*/, (0, client_platform_web_network_1.fetch)(options)
                            .then(function (responseData) {
                            var _a, _b, _c, _d, _e, _f, _g, _h;
                            if (responseData.body) {
                                var resourceId = void 0;
                                // need to manually create resourceId since using the v4 endpoint
                                if (namespace == constants_1.COMMENTS_NAMESPACES.PARTS) {
                                    resourceId = responseData.partId.toString();
                                }
                                else if (namespace == constants_1.COMMENTS_NAMESPACES.PARAGRAPHS) {
                                    resourceId =
                                        responseData.partId.toString() + "_" + responseData.paragraphId;
                                }
                                else {
                                    resourceId = responseData.parentId;
                                }
                                // not using buildCommentObject since not using the v5 endpoint
                                // v4 returns different response than v5
                                var postedComment = {
                                    resource: {
                                        namespace: namespace,
                                        resourceId: resourceId,
                                    },
                                    user: {
                                        name: responseData.author.name,
                                        avatar: responseData.author.avatar,
                                        isStaff: !!((_b = (_a = responseData === null || responseData === void 0 ? void 0 : responseData.author) === null || _a === void 0 ? void 0 : _a.badges) === null || _b === void 0 ? void 0 : _b.includes("staff")),
                                        isVerified: !!((_d = (_c = responseData === null || responseData === void 0 ? void 0 : responseData.author) === null || _c === void 0 ? void 0 : _c.badges) === null || _d === void 0 ? void 0 : _d.includes("verified")),
                                        isStar: !!((_f = (_e = responseData.author) === null || _e === void 0 ? void 0 : _e.badges) === null || _f === void 0 ? void 0 : _f.includes("star")),
                                        isAmbassador: !!((_h = (_g = responseData === null || responseData === void 0 ? void 0 : responseData.author) === null || _g === void 0 ? void 0 : _g.badges) === null || _h === void 0 ? void 0 : _h.includes("ambassador")),
                                    },
                                    commentId: {
                                        namespace: constants_1.COMMENTS_NAMESPACES.COMMENTS,
                                        resourceId: responseData.id,
                                    },
                                    text: responseData.body,
                                    created: responseData.createDate,
                                    modified: responseData.createDate,
                                    replyCount: responseData.numReplies,
                                    deeplink: responseData.deeplink,
                                    isOffensive: responseData.isOffensive,
                                    isReply: responseData.isReply,
                                    sentiments: new Map(),
                                };
                                return postedComment;
                            }
                            // handles 4xx api errors
                            var apiErr = {
                                error: responseData.error,
                                description: responseData.description,
                            };
                            return Promise.reject(apiErr);
                        })
                            .catch(function (err) {
                            // network and abort errors have standard message fields
                            // errors from the v5 api have error and description fields
                            var error = err.error || err;
                            var description = err.description || err.message;
                            console.log("client-platform-comments: postComment Failed", "namespace:", resource.namespace, "error: ", description);
                            var errResponse = {
                                error: error,
                                description: description,
                            };
                            return Promise.reject(errResponse);
                        })];
            }
        });
    });
}
exports.postComment = postComment;
/**
 * Gets the comments under a given resource.
 *
 * @param {TempResource} resource The namespace and id(s) of a resource.
 * @param resource.namespace Namespace of a resource.
 * @param resource.partId Id of a story part.
 * @param resource.paragraphId Id of a paragraph within a story part.
 * @param resource.commentId Id of a comment.
 * @param {Resource} after Resource indicating the last fetched resource. For pagination.
 * @param limit The number of comments to fetch at a time. Default value is 10
 * @returns CommentsResult object if fetch is successful, otherwise returns a rejected promise.
 */
function fetchComments(resource, // Have to have a nice way to wrap partId & paragraphId
after, // commentId (optional)
limit // (optional)
) {
    return __awaiter(this, void 0, void 0, function () {
        var searchQuery, queryString, resourceId, options, commentsData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    searchQuery = new URLSearchParams();
                    // create string for query parameters
                    // as query parameters, limit is a number and after is a resourceId (not an object)
                    limit && searchQuery.append("limit", limit.toString());
                    (after === null || after === void 0 ? void 0 : after.resourceId) && searchQuery.append("after", after.resourceId);
                    queryString = "?" + searchQuery.toString().replace(/_/g, "%23");
                    // check parameter validity
                    return [4 /*yield*/, validateResourceParams(resource, "fetchComments")];
                case 1:
                    // check parameter validity
                    _a.sent();
                    if (resource.namespace === constants_1.COMMENTS_NAMESPACES.COMMENTS) {
                        resourceId = resource.commentId;
                    }
                    else if (resource.namespace === constants_1.COMMENTS_NAMESPACES.PARAGRAPHS) {
                        resourceId = resource.partId + "_" + resource.paragraphId;
                    }
                    else if (resource.namespace === constants_1.COMMENTS_NAMESPACES.PARTS) {
                        resourceId = resource.partId;
                    }
                    options = {
                        url: (0, helpers_1.buildDomain)("/v5/comments/namespaces/".concat(resource.namespace, "/resources/").concat(resourceId, "/comments").concat(queryString)),
                        method: "GET",
                        timeoutValue: constants_1.LONG_TIMEOUT_VALUE,
                        errorsWithJsonResponse: [400, 401, 403, 422],
                    };
                    commentsData = (0, client_platform_web_network_1.fetch)(options)
                        .then(function (responseData) {
                        if (responseData.comments) {
                            return responseData;
                        }
                        // handles 4xx api errors
                        var apiErr = {
                            error: responseData.error,
                            description: responseData.description,
                        };
                        return Promise.reject(apiErr);
                    })
                        .catch(function (err) {
                        // network and abort errors have standard message fields
                        // errors from the v5 api have error and description fields
                        var error = err.error || err;
                        var description = err.description || err.message;
                        console.log("client-platform-comments: fetchComments Failed", "namespace:", resource.namespace, "resourceId:", resourceId, "error: ", description);
                        var errResponse = {
                            error: error,
                            description: description,
                        };
                        return Promise.reject(errResponse);
                    });
                    return [2 /*return*/, commentsData
                            .then(function (values) {
                            var comments = values.comments.map(function (comment) {
                                return buildCommentObject(comment);
                            });
                            var after = values.pagination.after || null;
                            var result = __assign({ hasMore: !!after, comments: comments }, (!!after && {
                                after: after,
                            }));
                            return result;
                        })
                            .catch(function (err) {
                            var errResponse = {
                                error: err.error,
                                description: err.description,
                            };
                            return Promise.reject(errResponse);
                        })];
            }
        });
    });
}
exports.fetchComments = fetchComments;
/**
 * Returns the comment object given a resource.
 *
 * @param {Resource} resource The resource identifier of the comment to be fetched
 * @param resource.namespace Namespace of the resource. Can only be "comments"; anything else will return an error
 * @param resource.resourceId Resource ID of the target comment to be fetched.
 * @returns comment: Comment the comment object(s) information
 * - comment: The comment object information of the given resource
 **/
function fetchComment(resource) {
    return __awaiter(this, void 0, void 0, function () {
        var errMessage, description, logMessage, errMessage, description, logMessage, errMessage, description, logMessage, errMessage, description, logMessage, commentId, url, options, commentData;
        return __generator(this, function (_a) {
            // check if valid resource
            if (!resource) {
                errMessage = "client-platform-comments: fetchComment Invalid resource";
                description = "commentId cannot be null or undefined";
                logMessage = "client-platform-comments: fetchComment Failed\n" +
                    "resource: ".concat(resource, ",\nerror: ").concat(description);
                return [2 /*return*/, (0, helpers_1.invalidParam)(logMessage, errMessage, description)];
            }
            else if (resource.namespace !== constants_1.COMMENTS_NAMESPACES.COMMENTS) {
                errMessage = "client-platform-comments: fetchComment Invalid resource namespace";
                description = "resource namespace must be 'comments'";
                logMessage = "client-platform-comments: fetchComment Failed\n" +
                    "resource: {\n\t namespace: ".concat(resource.namespace, ",\n\t resourceId: ").concat(resource.resourceId, "\n},\n error: ").concat(description);
                return [2 /*return*/, (0, helpers_1.invalidParam)(logMessage, errMessage, description)];
            } // check if valid comment ID
            else if (!resource.resourceId) {
                errMessage = "client-platform-comments: fetchComment Invalid resource ID";
                description = "resourceId cannot be null or undefined";
                logMessage = "client-platform-comments: fetchComment Failed\n" +
                    "resource: {\n\t namespace: ".concat(resource.namespace, ",\n\t resourceId: ").concat(resource.resourceId, "\n},\n error: ").concat(description);
                return [2 /*return*/, (0, helpers_1.invalidParam)(logMessage, errMessage, description)];
            }
            else if (typeof resource.resourceId !== "string") {
                errMessage = "client-platform-comments: fetchComment Invalid resourceId type";
                description = "resourceId must be a string";
                logMessage = "client-platform-comments: fetchComment Failed\n" +
                    "resource: {\n\t namespace: ".concat(resource.namespace, ",\n\t resourceId: ").concat(resource.resourceId, "\n},\n error: ").concat(description);
                return [2 /*return*/, (0, helpers_1.invalidParam)(logMessage, errMessage, description)];
            }
            commentId = resource.resourceId;
            url = (0, helpers_1.buildDomain)("/v5/comments/comments/".concat(commentId));
            options = {
                url: url,
                method: "GET",
                timeoutValue: constants_1.LONG_TIMEOUT_VALUE,
            };
            commentData = (0, client_platform_web_network_1.fetch)(options)
                .then(function (responseData) {
                // if responseData json is an error
                if (responseData.error) {
                    // handles 4xx api errors
                    var apiErr = {
                        error: responseData.error,
                        description: responseData.description,
                    };
                    return Promise.reject(apiErr);
                }
                else {
                    var commentResponse = buildCommentObject(responseData);
                    return commentResponse;
                }
            })
                .catch(function (err) {
                // network and abort errors have standard message fields
                // errors from the v5 api have error and description fields
                var error = err.error || err;
                var description = err.description || err.message;
                console.log("client-platform-comments: fetchComment Failed\n", "resource: {\n\tnamespace: ".concat(resource.namespace, ",\n\t"), "resourceId: ".concat(resource.resourceId, "\n},\n"), "error: ".concat(description));
                var errResponse = {
                    error: error,
                    description: description,
                };
                return Promise.reject(errResponse);
            });
            return [2 /*return*/, commentData];
        });
    });
}
exports.fetchComment = fetchComment;
/**
 * Deletes a given comment
 *
 * @param commentId The ID of the comment to be deleted.
 * @returns Returns true if successful. Rejected promise on failure.
 */
function deleteComment(commentId) {
    if (!commentId) {
        var errMessage = "client-platform-comments: deleteComment Invalid commentId";
        var description = "commentId cannot be null or undefined";
        var logMessage = "client-platform-comments: deleteComment Failed commentId: ".concat(commentId, ", error: ").concat(description);
        return (0, helpers_1.invalidParam)(logMessage, errMessage, description);
    }
    else if (typeof commentId !== "string") {
        var errMessage = "client-platform-comments: deleteComment Invalid commentId type";
        var description = "commentId must be a string";
        var logMessage = "client-platform-comments: deleteComment Failed commentId: ".concat(commentId, ", error: ").concat(description);
        return (0, helpers_1.invalidParam)(logMessage, errMessage, description);
    }
    var options = {
        url: (0, helpers_1.buildDomain)("/v4/comments/".concat(commentId)),
        method: "DELETE",
        timeoutValue: constants_1.SHORT_TIMEOUT_VALUE,
    };
    var responseData = (0, client_platform_web_network_1.fetch)(options)
        .then(function (responseData) {
        if (responseData.code === 200) {
            return Promise.resolve(true);
        }
        var err = {
            error: responseData.error,
            description: responseData.description,
        };
        return Promise.reject(err);
    })
        .catch(function (errorResult) {
        var error = errorResult.error || errorResult;
        var description = errorResult.description || errorResult.message;
        console.log("client-platform-comments: deleteComment Failed", "commentId", commentId, "error: ", description);
        var err = {
            error: error,
            description: description,
        };
        return Promise.reject(err);
    });
    return responseData;
}
exports.deleteComment = deleteComment;
